export { default } from './TaskExecLightItem';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecLightItem/index.js